module.exports = __webpack_public_path__ + "static/media/user-icon.f582300b.svg";